import { Card } from "@/components/ui/card";

export function PageHeader({ title, subtitle, children, icon: Icon }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="flex items-center gap-2 font-head text-2xl font-bold tracking-tight sm:text-3xl">
          {Icon && <Icon className="h-6 w-6 text-accent" />} {title}
        </h1>
        {subtitle && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, text, action }) {
  return (
    <Card className="flex flex-col items-center justify-center gap-3 border-dashed p-10 text-center">
      {Icon && <Icon className="h-10 w-10 text-muted-foreground/50" />}
      <div>
        <p className="font-head text-lg font-semibold">{title}</p>
        {text && <p className="mt-1 max-w-md text-sm text-muted-foreground">{text}</p>}
      </div>
      {action}
    </Card>
  );
}

export function Stat({ label, value, tone = "default", icon: Icon, hint }) {
  const tones = {
    default: "text-foreground", danger: "text-red-600", warn: "text-amber-600",
    ok: "text-emerald-600", accent: "text-accent",
  };
  return (
    <Card className="p-4">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
        {Icon && <Icon className={`h-4 w-4 ${tones[tone]}`} />}
      </div>
      <div className={`mt-2 font-head text-3xl font-extrabold ${tones[tone]}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </Card>
  );
}
